var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vm-search-com",style:(_vm.vmSearchStyle)},[_c('div',{staticClass:"vm-search-label",style:(_vm.labelStyle)},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }